export const reportAdvancePaymentsTypes = {
  SET_REPORT_ADVANCE_PAYMENTS_FILTERS: 'SET_REPORT_ADVANCE_PAYMENTS_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
